/**
 * Panel wrapper for Starting / Closing balance sections.
 */
export function BalanceSection({
  title,
  subtitle = null,
  tone = "starting",
  step = null,
  actions = null,
  children,
  footer = null,
}) {
  const tones = {
    starting: {
      bar: "bg-emerald-600",
      badge: "bg-emerald-50 border-emerald-200 text-emerald-800",
      footer: "bg-emerald-50/60 border-emerald-100",
    },
    closing: {
      bar: "bg-blue-600",
      badge: "bg-blue-50 border-blue-200 text-blue-800",
      footer: "bg-blue-50/60 border-blue-100",
    },
  };
  const style = tones[tone] || tones.starting;

  return (
    <section className="flex h-full flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      <div className={`h-1.5 w-full ${style.bar}`} />

      <div className="flex items-start justify-between gap-3 border-b border-gray-100 px-5 py-4">
        <div>
          <div className="flex flex-wrap items-center gap-2">
            {step != null && (
              <span
                className={`inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold text-white ${style.bar}`}
              >
                {step}
              </span>
            )}
            <span
              className={`inline-flex rounded-md border px-2.5 py-1 text-xs font-semibold uppercase tracking-wide ${style.badge}`}
            >
              {title}
            </span>
          </div>
          {subtitle && (
            <p className="mt-2 max-w-md text-xs leading-relaxed text-gray-500">
              {subtitle}
            </p>
          )}
        </div>
        {actions && (
          <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
            {actions}
          </div>
        )}
      </div>

      <div className="flex-1 space-y-5 px-5 py-5">{children}</div>

      {footer && (
        <div className={`border-t px-5 py-4 ${style.footer}`}>{footer}</div>
      )}
    </section>
  );
}
